module.exports = __webpack_public_path__ + "static/media/casaAluguel.3fc47bfb.png";